var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-side-content"},[_c('div',{staticClass:"container-left"},[_c('h2',{staticClass:"welcome-text"},[_vm._v(" "+_vm._s(_vm.$t("login.leftSide.title"))+" "),_c('br'),_c('strong',[_vm._v(_vm._s(_vm.$t('login.leftSide.subtitleStrong')))]),_vm._v(" "+_vm._s(_vm.$t('login.leftSide.subtitle'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }